

export class VehicleTypeSelectOutputWithStatus implements IVehicleTypeSelectOutputWithStatus {
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id!: number;
    /** The vehicle type name with 255 character limit */
    vehicle_type_name!: string;
    /** Manage status of vehicle type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IVehicleTypeSelectOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_type_id = _data["vehicle_type_id"];
            this.vehicle_type_name = _data["vehicle_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleTypeSelectOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeSelectOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_type_id"] = this.vehicle_type_id;
        data["vehicle_type_name"] = this.vehicle_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleTypeSelectOutputWithStatus {
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id: number;
    /** The vehicle type name with 255 character limit */
    vehicle_type_name: string;
    /** Manage status of vehicle type. 0 For De-active, 1 For Active */
    status: number;
}

